import React from 'react';
import './AdminStudentRegistration.css';
import { isSuperAdmin, hasPermission } from '../../utils/auth';

const AdminStudentRegistrationHome = ({ onNavigate }) => {
  // Setup and Import are super_admin only -- branch_admin no longer sees
  // these tiles (setup-time/roster-loading activity, not day-to-day use).
  const canSetup = isSuperAdmin();
  // Only mention grade evaluation in the tile if this user can actually do
  // it here — a Registrar-only user's grade field is read-only, so calling
  // it "Grade Evaluation" would be misleading for them.
  const canEvaluateGrade = hasPermission('grade_evaluation');

  const tiles = [
    canSetup && {
      icon: '⚙️',
      title: 'Setup',
      desc: 'Academic years, registration fee, grades, and each grade\'s book list.',
      page: 'admin-student-registration-setup',
    },
    canSetup && {
      icon: '📥',
      title: 'Import Students',
      desc: 'Bulk-load a roster from a CSV for one branch and academic year.',
      page: 'admin-student-registration-import',
    },
    {
      icon: '🔍',
      title: canEvaluateGrade ? 'Registration / Grade Evaluation Updates' : 'Registration Updates',
      desc: canEvaluateGrade
        ? 'Search for a student, confirm registration, payment, volunteering, books, and grade.'
        : 'Search for a student, confirm registration, payment, volunteering, and books.',
      page: 'admin-student-registration-checkin',
    },
    {
      icon: '📋',
      title: 'Roster',
      desc: 'This year\'s registrations — who\'s registered and who still owes a balance.',
      page: 'admin-student-registration-roster',
    },
  ].filter(Boolean);

  return (
    <div className="admin-home sr-home">
      <div className="welcome-section sr-home-banner">
        <h1>Student Registration</h1>
        <p>Registration, fees, volunteering, and book distribution — usable any time of year, not just distribution day.</p>
      </div>
      <div className="admin-cards">
        {tiles.map(t => (
          <button key={t.page} className="admin-card admin-card-btn" onClick={() => onNavigate(t.page)}>
            <div className="card-icon">{t.icon}</div>
            <h3>{t.title}</h3>
            <p>{t.desc}</p>
          </button>
        ))}
      </div>
    </div>
  );
};

export default AdminStudentRegistrationHome;
